module.exports = __webpack_public_path__ + "static/img/1.d558062.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/20/zh/1.png
// module id = EQB6
// module chunks = 0